function createSelectOptions(arr = [], key) {
  return arr.reduce(
    (acc, curr) => ({
      ...acc,
      [String(curr[key])]: curr
    }),
    {}
  );
}
export {
  createSelectOptions
};
//# sourceMappingURL=create-select-options.js.map
